// src/components/reviews/components/ReviewStats.jsx
import React from 'react';
import { Star, MessageSquare, Clock } from 'lucide-react';

// shadcn components
import { Card, CardContent } from '../../ui/card';

/**
 * Review Stats - Displays aggregate review statistics
 */
const ReviewStats = ({ averageRating, totalReviewCount, pendingRepliesCount }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
      {/* Average Rating */}
      <Card>
        <CardContent className="pt-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium text-gray-600">Average Rating</p>
              <p className="text-3xl font-bold mt-1">{averageRating?.toFixed(1) || '0.0'}</p>
            </div>
            <div className="bg-yellow-100 p-3 rounded-full">
              <Star className="h-6 w-6 text-yellow-600 fill-yellow-600" />
            </div>
          </div>
        </CardContent>
      </Card>

      {/* Total Reviews */}
      <Card>
        <CardContent className="pt-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium text-gray-600">Total Reviews</p>
              <p className="text-3xl font-bold mt-1">{totalReviewCount || 0}</p>
            </div>
            <div className="bg-blue-100 p-3 rounded-full">
              <MessageSquare className="h-6 w-6 text-blue-600" />
            </div>
          </div>
        </CardContent>
      </Card>

      {/* Pending Replies */}
      <Card>
        <CardContent className="pt-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium text-gray-600">Pending Replies</p>
              <p className="text-3xl font-bold mt-1">{pendingRepliesCount || 0}</p>
            </div>
            <div className={`${pendingRepliesCount > 0 ? 'bg-orange-100' : 'bg-green-100'} p-3 rounded-full`}>
              <Clock className={`h-6 w-6 ${pendingRepliesCount > 0 ? 'text-orange-600' : 'text-green-600'}`} />
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default ReviewStats;
